<template>
    <div v-if=config>
        <div 
            @click="$emit('click')"
            class = "baseCalendar-date-picker">
            <flat-pickr 
                v-model="date"
                ref="baseCalendar"
                :config="config"
                :placeholder=placeholder
                @on-change="timeChanged"
            />
        </div>
    </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';

    export function enforceFifteenMinIncrements(dstr, dobjs, fp) {
        setTimeout( () => {
            const d = fp.latestSelectedDateObj || new Date();
            const mins = d.getMinutes();

            if (mins % 15)
                d.setMinutes(15*Math.ceil(d.getMinutes() / 15));
            fp.setDate(d, false);
        }, 500);
    }

    export default {
        props: {
            'config': {
                 type: Object   
            }, 
        placeholder: {
            type: String,
            default: "Pick a Date and Time"
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        positionElement: {
            default: null
        }
        },
        mounted() {
            this.fp = this.$refs.baseCalendar.fp;
        },
        data () {
            return {
                date: null,       
                fp: null
            }
        },
        components: {
            flatPickr
        },
        methods: {
            timeChanged(val) {
                this.$emit('on-change', new Date(val));
            }
        },
        watch: {
            isOpen(newValue, oldValue) {
                if (newValue) {
                   if(this.positionElement) {
                       this.fp._positionElement
                   }
                   this.fp.open();
                } else {
                    this.fp.close();
                }
            }
        }
}
</script>

<style lang = "scss">
    .flatpickr-input {
        display: none;
    }
</style>




// WEBPACK FOOTER //
// src/components/common/BaseCalendarPicker.vue